import pinSettings from '@/components/pinning/pin-settings/pin-settings.vue';

const MENU = [
  {
    page: 'market-details',
    label: 'Markets',
    items: [
      { widget: 'watchlist', label: 'Watchlist', side: 'left' },
      { widget: 'session-history', label: 'Session List', side: 'left' },
    ],
  },
  {
    page: 'social',
    label: 'Social',
    items: [
      { widget: 'market-discussion', label: 'Discussion', side: 'right' },
    ],
  },
];

export default {
  components: { pinSettings },
  data() {
    return { menu: MENU };
  },
};



// WEBPACK FOOTER //
// ./src/components/pinning/pin-settings-market-details/pin-settings-market-details.js